import {
  graphqlCall,
  validateLockPin as validateLockPinGraphql,
  ValidateLockPinQuery,
} from '@akin-home/amplify';
import { ValidateLockPINResponse } from '@akin-home/lock-screen';

interface Params {
  /** ID of the user having their PIN set */
  user_id: string;

  /** The string value of the PIN */
  pin: string;
}

export const validateLockPin = async ({
  user_id,
  pin,
}: Params): Promise<ValidateLockPINResponse> => {
  try {
    const res = await graphqlCall<ValidateLockPinQuery>(
      validateLockPinGraphql,
      {
        params: JSON.stringify({
          user_id,
          pin,
        }),
      }
    );

    if (res.errors?.length)
      return { success: false, error: res.errors[0].message };

    if (!res.data.validateLockPIN)
      return { success: false, error: 'No Reponse' };

    return JSON.parse(res.data.validateLockPIN) as ValidateLockPINResponse;
  } catch (ex) {
    return { success: false, error: ex as string };
  }
};
